import './password-form.scss';
import { yupResolver } from '@hookform/resolvers/yup';
import {
  useCallback,
} from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import * as yup from 'yup';
import PrimaryButton from '../../buttons/primary-button/primary-button';
import PasswordField from '../../form-fields/password-field';

const schema = yup
  .object({
    currentPassword: yup
      .string()
      .required('Enter current password. Field cannot be blank.'),
    newPassword: yup
      .string()
      .required('Enter new password. Field cannot be blank.')
      .min(10, '10 characters minimum'),
    confirmPassword: yup
      .string()
      .required('Enter confirm password. Field cannot be blank.')
      .oneOf([yup.ref('newPassword'), null], 'Passwords must match'),
  })
  .required();

const PasswordForm = ({
  onCancel, onSubmit, submitting,
}) => {
  const methods = useForm({
    resolver: yupResolver(schema),
    mode: 'all',
    defaultValues: {
      currentPassword: '',
      newPassword: '',
      confirmPassword: '',
    },
  });

  const handleSubmit = useCallback((formValues) => {
    onSubmit(formValues);
  }, [onSubmit]);

  return (
    <div className="password-form">
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(handleSubmit)}>
          <div className="password-form__content">
            <div className="password-form__section">
              <div className="password-form__section__title">
                <h4>Password</h4>
              </div>

              <div className="password-form__section__form">
                <PasswordField
                  name="currentPassword"
                  label="Current password"
                />
                <PasswordField
                  name="newPassword"
                  label="New password"
                />
                <PasswordField
                  name="confirmPassword"
                  label="Confirm password"
                />
              </div>
            </div>

            <div className="password-form__actions">
              <button
                type="button"
                className="button button--default"
                onClick={onCancel}
              >
                Cancel
              </button>

              <PrimaryButton title="Save" isLoading={submitting} />
            </div>
          </div>
        </form>
      </FormProvider>
    </div>
  );
};

export default PasswordForm;
